import { MemberInfo, TideClientConfig } from "@qite/tide-client";
import { JwtPayload, jwtDecode } from "jwt-decode";

interface MemberInfoPayload extends JwtPayload {
  company: string;
  companyName: string;
  language: string;
  member: string;
  email: string;
  unique_name: string;
  addressId: string;
  addressName: string;
  addressLogo: string;
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid": string;
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name": string;
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress": string;
}

export const decodeTokenToMemberInfo = (token: string | null): MemberInfo | undefined => {
  if (!token) {
    return undefined;
  }

  const decodedToken = jwtDecode<MemberInfoPayload>(token);
  let member: MemberInfo | undefined = undefined;
  // check if token is not expired
  if (decodedToken?.exp && decodedToken.exp * 1000 < new Date().getTime()) {
    return undefined;
  }

  if (decodedToken) {
    member = {
      id: decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid"]
        ? parseInt(decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid"])
        : 0,
      companyId: decodedToken.company ? parseInt(decodedToken.company) : 0,
      companyName: decodedToken.companyName,
      name: decodedToken.unique_name,
      email: decodedToken.email || decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"],
      language: decodedToken.language,
      agentId: decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid"]
        ? parseInt(decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid"])
        : 0,
      addressId: decodedToken.addressId ? parseInt(decodedToken.addressId) : undefined,
      addressName: decodedToken.addressName,
      addressLogo: decodedToken.addressLogo,
    } as MemberInfo;
  }
  return member;
};

export const getTideClientConfig = (): TideClientConfig => {
  const host = process.env.GATSBY_TIDE_HOST;
  const apiKey = process.env.GATSBY_TIDE_API_KEY;

  if (!host || !apiKey) {
    throw new Error("Tide host or API key not provided.");
  }

  const token = getToken();

  return {
    host,
    apiKey,
    token,
  };
};

const getToken = (): string | undefined => {
  if (typeof localStorage !== "undefined") {
    return localStorage.getItem("token") || undefined;
  }

  return undefined;
};
